<template>
  <section class="bloc-player-auto-video-embed  scroll-step js-scroll-show">
    <div class="bloc-player-auto-video-embed__player">
      <video v-if="portrait && content.video_src_portrait" id="player" class="bloc-video__video video-portrait" playsinline ref="playerDOMPortrait">
        <source :src="content.internalFile ? require(`@/${content.video_src_portrait}`) : content.video_src_portrait" type="video/mp4" />
      </video>
      <video v-else-if="!portrait && content.video_src_landscape" id="player" class="bloc-video__video video-landscape" playsinline ref="playerDOMLandscape">
        <source :src="content.internalFile ? require(`@/${content.video_src_landscape}`) : content.video_src_landscape" type="video/mp4" />
      </video>
    </div>
  </section>
</template>

<script>
import Plyr from 'plyr'
import config from '@/config';

export default {
  name: 'PlayerAutoVideoEmbed',
  props: {
    content: {
      type: Object,
      required: true
    },
    forcePortrait: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      portrait: config.small || this.forcePortrait,
    }
  },
  mounted () {
     this.player = new Plyr((this.portrait ? this.$refs.playerDOMPortrait : this.$refs.playerDOMLandscape), {
      controls: [],
      ratio: this.portrait ? '9:16' : '16:9',
      autoplay: true,
      autopause: false,
      loop: {
        active: true,
      },
      muted: true,
      vimeo: { 
        muted: true,
      },
    })

    setTimeout(() => {
      this.player.volume = 0
      this.player.play()
    }, 100)
  }
}
</script>

<style lang="scss">
  .bloc-player-auto-video-embed {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    pointer-events: none;

    &__player {
      width: 100%;
      height: 100%;
      position: relative;
      top: 50%;
      flex: none;
      transform: translateY(-50%);

      .plyr {
        height: 100%;
      }
    }

    .video-portrait {
      object-fit: cover;
    }

    .video-landscape {
      object-fit: cover;
    }
  }
</style>
